import {
  RegistrantFilter,
  REGISTRANT_FILTER_TYPE,
  AudienceCardProps,
  AUDIENCE_CARD_TYPE,
} from '@/types/registration.types';

export const getFilterTitleFromStatus = (status: string): string => {
  switch (status) {
    case REGISTRANT_FILTER_TYPE.ALL_PROFILES:
      return 'All Profiles';
    case REGISTRANT_FILTER_TYPE.REGISTERED:
      return 'Registered';
    case REGISTRANT_FILTER_TYPE.ATTENDED:
      return 'Attended';
    case 'invited,registered':
      return 'No Shows';
    case REGISTRANT_FILTER_TYPE.NO_SHOWS:
      return 'No Shows';
    default:
      return 'Registrants';
  }
};

export const getStatusQueryParam = (filterType: REGISTRANT_FILTER_TYPE): string => {
  switch (filterType) {
    case REGISTRANT_FILTER_TYPE.REGISTERED:
      // 'registered' includes all statuses (invited, registered, attended), which is same as 'all'
      return REGISTRANT_FILTER_TYPE.ALL_PROFILES;
    case REGISTRANT_FILTER_TYPE.NO_SHOWS:
      return 'invited,registered';
    default:
      return filterType;
  }
};

export const canEdit = (status: string): boolean => {
  return status === REGISTRANT_FILTER_TYPE.REGISTERED;
};

export const generateDefaultRegistrantFilters = (counts: Record<string, number>): RegistrantFilter[] => {
  const allCount = counts.total ?? 0;
  const registeredCount = allCount;
  const attendedCount = counts.attended ?? 0;
  const noShowsCount = (counts.invited ?? 0) + (counts.registered ?? 0);

  return [
    {
      name: 'All',
      type: REGISTRANT_FILTER_TYPE.ALL_PROFILES,
      member_count: allCount,
    },
    {
      name: 'Registered',
      type: REGISTRANT_FILTER_TYPE.REGISTERED,
      member_count: registeredCount,
    },
    {
      name: 'Attended',
      type: REGISTRANT_FILTER_TYPE.ATTENDED,
      member_count: attendedCount,
    },
    {
      name: 'No shows',
      type: REGISTRANT_FILTER_TYPE.NO_SHOWS,
      member_count: noShowsCount,
    },
  ];
};

export const generateDefaultAudienceCardProps = (
  counts: Record<string, number>,
  projectName?: string
): AudienceCardProps[] => {
  return [
    {
      name: 'Registered',
      subHeader: projectName || '',
      audienceCardType: AUDIENCE_CARD_TYPE.REGISTERED,
      member_count: counts.registered ?? 0,
    },
    {
      name: 'Attended',
      subHeader: projectName || '',
      audienceCardType: AUDIENCE_CARD_TYPE.ATTENDED,
      member_count: counts.attended ?? 0,
    },
    {
      name: 'No shows',
      subHeader: projectName || '',
      audienceCardType: AUDIENCE_CARD_TYPE.NO_SHOWS,
      member_count: counts.no_shows ?? 0,
    },
  ];
};
